import dataset from '../datasets/misc.json';
import { regionIds } from '../localization/regionIds';
import { IMPERIAL, METRIC } from '../types';

export const getProcessingCriteria = () => {
  try {
    return dataset['processing_criteria'];
  } catch (e) {
    console.error('getProcessingCriteria');
    return null;
  }
};
export const getLevelsEnumCriteria = () => {
  try {
    return dataset['levels_enum'];
  } catch (e) {
    console.error('getLevelsEnumCriteria');
    return null;
  }
};

export const convertUnits = (value, unitType, unit) => {
  let unitValue = 0;
  switch (unit) {
    case METRIC:
      switch (unitType) {
        case 'cf': // Cubic feet to cubic meters
          unitValue = parseFloat((Math.round((value / 35.315) * 100) / 100).toString()).toFixed(2);
          break;
        case 'ft': // Feet to meters
          unitValue = parseFloat((Math.round(value * 0.3048 * 100) / 100).toString()).toFixed(2);
          break;
        case 'sf':
          unitValue = parseFloat((Math.round((value / 10.764) * 100) / 100).toString()).toFixed(2);
          break;
        case 'in': // Inches to mm
          unitValue = Math.round(value * 25.4);
          break;
        default:
          unitValue = Math.round(value * 100) / 100;
          break;
      }
      break;
    case IMPERIAL:
      // Round all the quantities to show only 2 decimals
      unitValue = Math.round(value * 100) / 100;
      break;
    default:
      break;
  }
  return unitValue;
};

/**
 * Prepares email to be sent for Alerts on DrawingAndReports and TopBar components
 * @param processingEntityState - values
 * @param regionId
 * @param contentLang
 * @returns {string|null}
 */
export const getAlertMailtoTemplate = (processingEntityState, regionId, contentLang) => {
  try {
    const processingEntity = processingEntityState;
    const newVolVal = convertUnits(processingEntity.systemVolume, 'cf', processingEntity.unit);
    const unitType = processingEntity.unit === METRIC ? ' m3' : ' cf';
    const mailToBody = encodeURIComponent(
      'Customer: ' +
        processingEntity.customer +
        '\n' +
        'Email: ' +
        processingEntity.email +
        '\n' +
        'Company: ' +
        processingEntity.company +
        '\n' +
        'City: ' +
        processingEntity.city +
        '\n' +
        (regionId === regionIds.usa
          ? 'State: ' + processingEntity.state
          : 'Country/Province: ' + processingEntity.country) +
        '\n' +
        'Phone: ' +
        processingEntity.phone +
        '\n' +
        'Chamber: ' +
        processingEntity.chamber +
        '\n' +
        'Number of Chambers: ' +
        processingEntity.numChambers +
        '\n' +
        //"Unit: " + processingEntity.unit + "\n" +
        'System Volume: ' +
        newVolVal +
        unitType +
        '\n\n' +
        'ADS Engineering Services,' +
        '\n\n' +
        'I received a warning message in the ADS Design Tool 2.0 indicating that my current design would likely not produce drawings.' +
        '\n\n' +
        'Additional Comments: \n',
    );

    return `mailto:ADSDesignTool@ads-pipe.com?subject=ADS Design Tool System Processing Warning - ${processingEntity.projName}&body=${mailToBody}`;
  } catch (e) {
    console.error(`Error on misc_utils.js:getAlertMailtoTemplate: ${e.message}`);
    return null;
  }
};

/**
 * This function will generate an array of coordinates of all chambers that should include Feed Connectors, and an
 * array of chambers where feed connectors should be removed
 * @param chamberBed
 * @param mainManifolds
 * @returns {*}
 */
export const shouldChamberPlaceFeedConnector = (chamberBed, mainManifolds) => {
  let { chamberRows } = chamberBed;
  let { manifolds } = mainManifolds;
  let lastActiveChamberRow = chamberRows
    .slice()
    .reverse()
    .find((chamberRow) => chamberRow.getActiveCount());
  lastActiveChamberRow = lastActiveChamberRow ? lastActiveChamberRow.row : 0;
  let mapFeedConnectorChambers = [];
  let mapFeedConnectorIsolatorChambers = [];
  for (const manifold of manifolds) {
    for (const chamberRow of chamberRows) {
      if (lastActiveChamberRow !== chamberRow._row) {
        for (const chamber of chamberRow._chambers) {
          // Exclude chambers with isolator
          if (chamber._isIsolatorArray.length === 0) {
            const exists = mapFeedConnectorChambers.some(
              (obj) => obj.col === manifold._coordinates.col && obj.row === chamber._row,
            );
            if (!exists) mapFeedConnectorChambers.push({ col: manifold._coordinates.col, row: chamber._row });
          } else {
            const exists = mapFeedConnectorIsolatorChambers.some(
              (obj) => obj.col === manifold._coordinates.col && obj.row === chamber._row,
            );
            if (!exists) mapFeedConnectorIsolatorChambers.push({ col: manifold._coordinates.col, row: chamber._row });
          }
        }
      }
    }
  }
  return { mapFeedConnectorChambers, mapFeedConnectorIsolatorChambers };
};

export const getInspectorPortPos = (chamberBed) => {
  let { chamberRows } = chamberBed;
  for (const chamberRow of chamberRows) {
    for (let i = 0; i < chamberRow._chambers.length; i++) {
      if (
        chamberRow._chambers[i] &&
        chamberRow._chambers[i]._isIsolatorArray &&
        chamberRow._chambers[i]._isIsolatorArray.length > 0 &&
        i === chamberRow._chambers.length - 1
      ) {
        return { col: chamberRow._chambers[i]._col, row: chamberRow._chambers[i]._row };
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/lib/misc/misc_utils.js